import V from "../../hash/dist/emotion-hash.esm.js";
import C from "../../unitless/dist/emotion-unitless.esm.js";
import D from "../../memoize/dist/emotion-memoize.esm.js";
var N = `You have illegal escape sequence in your template literal, most likely inside content's property value.
Because you write your CSS inside a JavaScript string you actually have to do double escaping, so for example "content: '\\00d7';" should become "content: '\\\\00d7';".
You can read more about this here:
https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences`, x = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).", A = /[A-Z]|^ms/g, S = /_EMO_([^_]+?)_([^]*?)_EMO_/g, v = function(n) {
  return n.charCodeAt(1) === 45;
}, b = function(n) {
  return n != null && typeof n != "boolean";
}, E = /* @__PURE__ */ D(function(s) {
  return v(s) ? s : s.replace(A, "-$&").toLowerCase();
}), d = function(n, e) {
  switch (n) {
    case "animation":
    case "animationName":
      if (typeof e == "string")
        return e.replace(S, function(o, i, r) {
          return c = {
            name: i,
            styles: r,
            next: c
          }, i;
        });
  }
  return C[n] !== 1 && !v(n) && typeof e == "number" && e !== 0 ? e + "px" : e;
};
if (process.env.NODE_ENV !== "production") {
  var R = /(var|attr|counters?|url|element|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/, M = ["normal", "none", "initial", "inherit", "unset"], I = d, L = /^-ms-/, Y = /-(.)/g, w = {};
  d = function(n, e) {
    if (n === "content" && (typeof e != "string" || M.indexOf(e) === -1 && !R.test(e) && (e.charAt(0) !== e.charAt(e.length - 1) || e.charAt(0) !== '"' && e.charAt(0) !== "'")))
      throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + e + "\"'`");
    var o = I(n, e);
    return o !== "" && !v(n) && n.indexOf("-") !== -1 && w[n] === void 0 && (w[n] = !0, console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + n.replace(L, "ms-").replace(Y, function(i, r) {
      return r.toUpperCase();
    }) + "?")), o;
  };
}
var _ = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function f(s, n, e) {
  if (e == null)
    return "";
  if (e.__emotion_styles !== void 0) {
    if (process.env.NODE_ENV !== "production" && e.toString() === "NO_COMPONENT_SELECTOR")
      throw new Error(_);
    return e;
  }
  switch (typeof e) {
    case "boolean":
      return "";
    case "object": {
      if (e.anim === 1)
        return c = {
          name: e.name,
          styles: e.styles,
          next: c
        }, e.name;
      if (e.styles !== void 0) {
        var o = e.next;
        if (o !== void 0)
          for (; o !== void 0; )
            c = {
              name: o.name,
              styles: o.styles,
              next: c
            }, o = o.next;
        var i = e.styles + ";";
        return process.env.NODE_ENV !== "production" && e.map !== void 0 && (i += e.map), i;
      }
      return j(s, n, e);
    }
    case "function": {
      if (s !== void 0) {
        var r = c, t = e(s);
        return c = r, f(s, n, t);
      } else
        process.env.NODE_ENV !== "production" && console.error("Functions that are interpolated in css calls will be stringified.\nIf you want to have a css call based on props, create a function that returns a css call like this\nlet dynamicStyle = (props) => css`color: ${props.color}`\nIt can be called directly with props or interpolated in a styled call like this\nlet SomeComponent = styled('div')`${dynamicStyle}`");
      break;
    }
    case "string":
      if (process.env.NODE_ENV !== "production") {
        var a = [], u = e.replace(S, function(m, h, p) {
          var y = "animation" + a.length;
          return a.push("const " + y + " = keyframes`" + p.replace(/^@keyframes animation-\w+/, "") + "`"), "${" + y + "}";
        });
        a.length && console.error("`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\nInstead of doing this:\n\n" + [].concat(a, ["`" + u + "`"]).join(`
`) + `

You should wrap it with \`css\` like this:

` + ("css`" + u + "`"));
      }
      break;
  }
  if (n == null)
    return e;
  var l = n[e];
  return l !== void 0 ? l : e;
}
function j(s, n, e) {
  var o = "";
  if (Array.isArray(e))
    for (var i = 0; i < e.length; i++)
      o += f(s, n, e[i]) + ";";
  else
    for (var r in e) {
      var t = e[r];
      if (typeof t != "object")
        n != null && n[t] !== void 0 ? o += r + "{" + n[t] + "}" : b(t) && (o += E(r) + ":" + d(r, t) + ";");
      else {
        if (r === "NO_COMPONENT_SELECTOR" && process.env.NODE_ENV !== "production")
          throw new Error(_);
        if (Array.isArray(t) && typeof t[0] == "string" && (n == null || n[t[0]] === void 0))
          for (var a = 0; a < t.length; a++)
            b(t[a]) && (o += E(r) + ":" + d(r, t[a]) + ";");
        else {
          var u = f(s, n, t);
          switch (r) {
            case "animation":
            case "animationName": {
              o += E(r) + ":" + u + ";";
              break;
            }
            default:
              process.env.NODE_ENV !== "production" && r === "undefined" && console.error(x), o += r + "{" + u + "}";
          }
        }
      }
    }
  return o;
}
var O = /label:\s*([^\s;\n{]+)\s*(;|$)/g, g;
process.env.NODE_ENV !== "production" && (g = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g);
var c, q = function(n, e, o) {
  if (n.length === 1 && typeof n[0] == "object" && n[0] !== null && n[0].styles !== void 0)
    return n[0];
  var i = !0, r = "";
  c = void 0;
  var t = n[0];
  t == null || t.raw === void 0 ? (i = !1, r += f(o, e, t)) : (process.env.NODE_ENV !== "production" && t[0] === void 0 && console.error(N), r += t[0]);
  for (var a = 1; a < n.length; a++)
    r += f(o, e, n[a]), i && (process.env.NODE_ENV !== "production" && t[a] === void 0 && console.error(N), r += t[a]);
  var u;
  process.env.NODE_ENV !== "production" && (r = r.replace(g, function(p) {
    return u = p, "";
  })), O.lastIndex = 0;
  for (var l = "", m; (m = O.exec(r)) !== null; )
    l += "-" + m[1];
  var h = V(r) + l;
  return process.env.NODE_ENV !== "production" ? {
    name: h,
    styles: r,
    map: u,
    next: c,
    toString: function() {
      return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
  } : {
    name: h,
    styles: r,
    next: c
  };
};
export {
  q as serializeStyles
};
//# sourceMappingURL=emotion-serialize.browser.esm.js.map
